import { Component, Input, OnInit } from '@angular/core';
import { Account } from '@jaimo-solutions-gmbh/platform-services-module';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { VerifiedTooltipComponent } from '@jaimo-solutions-gmbh/stage-components';
import { State } from 'src/helpers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss'],
})
export class DesktopHeaderComponent implements OnInit {
  VerifiedComponent = VerifiedTooltipComponent;

  @Input() account: Account;
  @Input() state: State;

  showActions: boolean = false;

  searchText: string = '';
  searchIcon = faSearch;
  clearIcon = faTimesCircle;

  observer: IntersectionObserver;

  constructor(private router: Router) {}

  ngOnInit() {
    const urlParams = new URLSearchParams(location.search);
    this.searchText = urlParams.get('searchText') ?? '';
  }

  ngOnChanges() {
    this.showActions = false;
    if (this.state !== 'stage') {
      this.observer?.disconnect();
      return;
    }

    this.addObserver();
  }

  ngAfterViewInit() {}

  addObserver = async () => {
    const MAX_TRIES = 10;
    let tries = 0;

    const observedElement = await new Promise<Element>((resolve) => {
      const interval = setInterval(() => {
        const element = document.querySelector('#profile-actions');

        if (element || tries === MAX_TRIES) {
          clearInterval(interval);
          resolve(element);
        }
        tries++;
      }, 500);
    });

    this.observer = new IntersectionObserver(
      (entry) => {
        entry.forEach(({ isIntersecting }) => {
          this.showActions = !isIntersecting;
        });
      },
      {
        rootMargin: '-64px 0px 0px 0px',
        threshold: 0.5,
      }
    );

    this.observer.observe(observedElement);
  };

  onInput = (value: string) => {
    this.searchText = value;
    if (!value) {
      this.clear();
    } else {
      this.router.navigate([`/search`], {
        queryParams: { searchText: this.searchText },
      });
    }
  };

  onFocus = () => {
    if (!this.searchText) return;

    this.router.navigate([`/search`], {
      queryParams: { searchText: this.searchText },
    });
  };

  clear = () => {
    this.searchText = '';
    this.router.navigate([this.state ?? '']);
  };
}
